import '../ui/tabs';

$(document).ready(function(){
     $('.js-newsletter-email').on('keyup change', function () {
        const $consents = $('.js-newsletter-consents'),
            value = $(this).val();

        if (value != '' && $(this).valid()) {
            $consents.slideDown(250);
        } else {
            $consents.slideUp(250);
        }
    });

    $('.js-form-subscription').validate({
        errorPlacement: function (error, element) {
            if (element.attr("type").match("checkbox")) {
                error.insertAfter(element.siblings("label"));
            } else {
                error.insertAfter(element);
            }
        },
        submitHandler: function (form) {
            const $form = $(form);
            const $submit = $form.find('[type="submit"]');

            $submit.prop('disabled', true).addClass('is-loading');

            $.post($form.attr('action'), $form.serialize(), function (data) {
                var msg = data.msg.format;

                if (!msg) {
                    msg = data.msg;
                }

                console.log('DATA', {data});
                if (!data.status) {
                    Eshop.alert(msg, { type: 'danger' });
                } else {
                    Eshop.alert(msg);
                    $('.js-newsletter-email').val('').trigger('change');
                    $('.js-newsletter-consents').find('input[type="checkbox"]').prop('checked', false);
                }
            }, 'json').fail(function(response) {
                console.log('RESP', {response});

                let msg = $form.data('general-error');

                if (response.status == 403) {
                    msg = $form.data('captcha-error');
                }

                Eshop.alert(msg, { type: 'danger' });
            }).always(function() {
                $submit.prop('disabled', false).removeClass('is-loading');
                rEvent.dispatch('Recaptcha.execute');
            });

            return false;
        }
    });
})